import { render, staticRenderFns } from "./newUser.vue?vue&type=template&id=25c059b9&scoped=true"
import script from "./newUser.vue?vue&type=script&lang=js"
export * from "./newUser.vue?vue&type=script&lang=js"
import style0 from "./newUser.vue?vue&type=style&index=0&id=25c059b9&prod&scoped=true&lang=css"
import style1 from "./newUser.vue?vue&type=style&index=1&id=25c059b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c059b9",
  null
  
)

export default component.exports